module.exports = __webpack_public_path__ + "img/wbtc.1a79a441.png";